<template>
  <RecordingsViewPage />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'default',
  contentClass: 'p-0',
})
</script>
